import { FILE_EXPLORER_CONTENT_TYPE } from '../../../constants/constants';
import { FolderContentType } from '../../../types/types';
import Styles from './ContentBox.module.scss'

import { ReactComponent as FolderIcon } from "../../../icons/file_types/macbook_folder.svg"
import { ReactComponent as MobileFolderIcon } from "../../../icons/file_types/samsung_folder.svg"
// import {ReactComponent as ImageIcon} from "../../../icons/file_types/folder.svg"
import { ReactComponent as PDFIcon } from "../../../icons/file_types/pdf.svg"
import { ReactComponent as WORDIcon } from "../../../icons/file_types/ms_word.svg"
import { useContext, useState } from 'react';
import ContentDialog from '../../dialog-content/ContentDialog';
import { AppContext } from '../../../contexts/AppContext';
import classNames from 'classnames';
// import {ReactComponent as Icon} from "../../../icons/file_types/folder.svg"

interface ContentBox {
    activeId: string;
    id: string;
    label: string;
    contentType: FILE_EXPLORER_CONTENT_TYPE.FOLDER | FILE_EXPLORER_CONTENT_TYPE.IMAGE | FILE_EXPLORER_CONTENT_TYPE.PDF | FILE_EXPLORER_CONTENT_TYPE.VIDEO | FILE_EXPLORER_CONTENT_TYPE.WORD,
    subOptions: FolderContentType[] | undefined;
    currentDirectory: string;
    sourceLink?: string;
    layoutType?: "mobileCompact",
    openDialogViewer?: (sourceLink: string, label: string) => void;
    onContentOpeneClick: (id: string, data: FolderContentType[] | undefined, label: string) => void;
    onSuccessfulFileClick?: () => void;
}

export const getFileTypeIcon = (contentType:string,isMobile:boolean=false,sourceLink:string="") => {
    switch (contentType) {
        case FILE_EXPLORER_CONTENT_TYPE.IMAGE: return <img src={sourceLink}/>
        case FILE_EXPLORER_CONTENT_TYPE.PDF: return <PDFIcon />
        case FILE_EXPLORER_CONTENT_TYPE.VIDEO: return <></>
        case FILE_EXPLORER_CONTENT_TYPE.WORD: return <WORDIcon />
        case FILE_EXPLORER_CONTENT_TYPE.FOLDER:
        default: return  isMobile ? <MobileFolderIcon/> : <FolderIcon />
    }
}

export const getFileExtension = (contentType:string) => {
    switch (contentType) {
        case FILE_EXPLORER_CONTENT_TYPE.IMAGE: return "png"
        case FILE_EXPLORER_CONTENT_TYPE.PDF: return "pdf"
        case FILE_EXPLORER_CONTENT_TYPE.VIDEO: return "mp4"
        case FILE_EXPLORER_CONTENT_TYPE.WORD: return "docx"
        case FILE_EXPLORER_CONTENT_TYPE.FOLDER:
        default: return ""
    }
}

const ContentBox = ({ activeId, id, label, contentType, layoutType, subOptions, sourceLink, currentDirectory, onContentOpeneClick, onSuccessfulFileClick,openDialogViewer }: ContentBox) => {

    const {isMobile} = useContext(AppContext)



    const openFile = () => {
        window.open(sourceLink, label, `width=400,height=700`)
    }

    const handleSelected = (id: string, data: FolderContentType[] | undefined, label: string) => {
        if (activeId != id) {
            contentType === FILE_EXPLORER_CONTENT_TYPE.FOLDER ? onContentOpeneClick(id, data, label) : openDialogViewer?.(sourceLink || "",label)
            contentType === FILE_EXPLORER_CONTENT_TYPE.FOLDER && onSuccessfulFileClick?.()
        }
    }


    return (
        <>
            <div className={classNames(Styles.container,layoutType && Styles[layoutType])} 
                onDoubleClick={isMobile ?  ()=>{} : () => { handleSelected(activeId + "@" + id, subOptions, currentDirectory + ">" + `${label}.${getFileExtension(contentType)}`) } }
                onClick={isMobile ? () => {handleSelected(activeId + "@" + id, subOptions, currentDirectory + ">" + `${label}.${getFileExtension(contentType)}`) }:  ()=>{} }
                
            >
                <div className={Styles.icon}>
                    {getFileTypeIcon(contentType,isMobile,sourceLink)}
                </div>
                <div className={Styles.label}>
                    {`${label}.${getFileExtension(contentType)}`}
                </div>
            </div>
            <>
            
           
            </>
        </>
    )
}

export default ContentBox
